import { gql } from "apollo-boost";

const GET_PRODUCT_DIFF_COUNTS = gql`
  query getProductDiffCounts {
    getProductDiffCounts {
      data {
        key
        count
      }
      error
      status
    }
  }
`;

export default GET_PRODUCT_DIFF_COUNTS;
